var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", {
    staticClass: "menu--tag",
    class: _vm.containerClasses,
    attrs: { title: _vm.tag.mt_title, "aria-label": _vm.tag.mt_title },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }